import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../template/Navbar";
import Footer from "../template/Footer";

function HomeLand() {
  return (
    <>
      <Navbar />
      <div>
        <Outlet />
      </div>
      <Footer />
    </>
  );
}

export default HomeLand;
